import React, { useContext } from 'react';
import { useCustomToast } from '@components/extra/useCustomToast';
import { GTM } from '@src/analytics/gtm';
import { gtmEvents } from '@src/analytics/gtmEventsConstant';
import {
  GlobalDispatchContext,
  GlobalStateContext,
} from '@src/context/GlobalContextProvider';

// Mirrors useCrioDownload's triggerPlacementStatsWebengageFlow (the pattern
// VideoTestimonialSection's "Download Placement Stats" button already uses
// site-wide), minus the QA/SD-specific sendActivityHandler call — that hook
// only branches between QA_PAGE and SD_PAGE LeadSquared activity codes, and
// there's no AI_ENGINEER equivalent code yet, so reusing it as-is would
// mislabel this page's downloads as coming from the SD page in LeadSquared.
const usePlacementStatsDownload = () => {
  const state = useContext(GlobalStateContext);
  const dispatch = useContext(GlobalDispatchContext);

  const notifyPlacementStatsToast = useCustomToast(
    'success',
    <div>
      <h2 className="font-base font-rubik text-lg">Success!</h2>
      <p className="font-rubik text-sm">
        You will receive the stats in your email shortly.
        <br /> (In case you have your adblocker turned on, please write to us
        at{' '}
        <a href="mailto:programs@criodo.com" className="font-bold">
          programs@criodo.com
        </a>{' '}
        to receive the stats)
      </p>
    </div>,
  );

  return function onSubmitPageOne(email, phone) {
    GTM.login({ userId: email, email, phone, whatsappNumber: phone });
    GTM.setEmail(email);

    if (!state.isEmailEventSubmitted) {
      GTM.track(gtmEvents.EMAIL_SUBMITTED, { location: 'AI_ENGINEER_PAGE' });
      dispatch({ type: 'SET_IS_EMAIL_EVENT_SUBMITTED', payload: true });
    }

    GTM.track(gtmEvents.DOWNLOAD_PLACEMENT_STAT_APPLIED_SUCCESSFULLY, {
      location: 'AI_ENGINEER_PAGE',
    });

    notifyPlacementStatsToast();
  };
};

export default usePlacementStatsDownload;
